import { render, staticRenderFns } from "./indi-info.vue?vue&type=template&id=0d4d645c&"
import script from "./indi-info.vue?vue&type=script&lang=js&"
export * from "./indi-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports